// extracted by mini-css-extract-plugin
export var cardIcon = "_8g-5";
export var cardIconUnframed = "_8g-9";
export var checkboxCard = "_8g-0";
export var checkboxCardSelected = "_8g-4";
export var disabled = "_8g-2";
export var interactive = "_8g-1";
export var outerBorder = "_8g-3";
export var spacerMedium = "_8g-8";
export var spacerSmall = "_8g-7";
export var spacerXsmall = "_8g-6";